import * as React from 'react'

import { Box, Line, Text } from '@factorialco/deprecated-design-system'
import officeBuilding from 'assets/images/office-building.svg'

import i18n from 'modules/core/lib/i18n'

const BlankSlate = () => (
  <Box gap="s32" padding="s32" background="grey000White" alignItems="center">
    <img src={officeBuilding} />
    <Box alignItems="center">
      <Text.Normal>{i18n.t('surveys.form.response.blank')}</Text.Normal>
      <Line />
    </Box>
  </Box>
)

export default BlankSlate
